var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndicacaoP2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 93,
  height: 95,
  viewBox: "0 0 93 95",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M46.2 91.3C69.6721 91.3 88.7 72.102 88.7 48.42C88.7 24.7381 69.6721 5.54004 46.2 5.54004C22.7278 5.54004 3.69995 24.7381 3.69995 48.42C3.69995 72.102 22.7278 91.3 46.2 91.3Z",
  fill: "url(#paint0_linear_20693_22895)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.4999 13.5601L79.1599 11.1201C79.1399 11.3401 79.0999 11.5801 79.0599 11.8001C78.1399 15.7201 72.4199 17.7201 66.2799 16.2801C60.1399 14.8401 55.9199 10.5001 56.8399 6.58009C56.8999 6.36009 56.9599 6.14009 57.0399 5.92009L48.1799 3.84009L35.3999 58.1201L76.6799 67.8401L89.4999 13.5601Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0798 75.98L39.3998 78.4C39.4198 78.18 39.4598 77.94 39.4998 77.72C40.4198 73.8 46.1398 71.8 52.2798 73.24C58.4198 74.68 62.6398 79.02 61.7198 82.94C61.6598 83.16 61.5998 83.38 61.5198 83.6L70.3798 85.68L74.7398 67.18L33.4598 57.46L29.0798 75.98Z",
  fill: "#FF5AAD"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4364 44.4776L70.0488 47.7116L49.8039 32.2055L52.184 29.0036L72.4364 44.4776ZM60.0428 47.4588C59.2042 51.0234 55.9477 53.3413 52.062 52.4271C48.5616 51.6037 46.2834 48.3226 47.1975 44.4369C48.0437 40.8402 51.2681 38.5147 55.1217 39.4213C58.6542 40.2523 60.9645 43.541 60.0428 47.4588ZM56.7106 46.641C57.1035 44.9711 55.9795 43.5544 54.3096 43.1615C52.4791 42.7309 50.9717 43.6641 50.6091 45.2056C50.2238 46.8433 51.3402 48.2922 53.0101 48.685C54.8085 49.1081 56.3555 48.1503 56.7106 46.641ZM74.7311 32.2746C73.8925 35.8391 70.636 38.157 66.7824 37.2504C63.2499 36.4194 60.9717 33.1383 61.8858 29.2526C62.732 25.6559 65.9885 23.338 69.8421 24.2446C73.3746 25.0756 75.6528 28.3568 74.7311 32.2746ZM71.3989 31.4567C71.7918 29.7869 70.6678 28.3701 68.9979 27.9773C67.1995 27.5542 65.6921 28.4874 65.3295 30.0289C64.9367 31.6988 66.0285 33.1079 67.6984 33.5008C69.4968 33.9238 71.0363 32.9982 71.3989 31.4567Z",
  fill: "#FF5AAD"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.2399 89.24L59.1599 85.7L58.8199 84.2C57.9999 80.64 55.2799 77.92 51.7199 77.08C48.1799 76.24 44.5199 77.48 42.1999 80.28L41.2199 81.46L26.1399 77.92L44.2999 0.719971L59.2599 4.23997L59.5999 5.79997C60.3399 9.43997 63.1399 12.36 66.7599 13.2C70.3799 14.04 74.1799 12.7 76.4599 9.75997L77.4399 8.49997L92.3999 12.04L74.2399 89.24ZM63.1999 81.54L70.5399 83.26L86.4399 15.7L79.2999 14.02C75.7799 17.62 70.5799 19.18 65.6199 18C60.6599 16.84 56.6999 13.12 55.1599 8.33997L48.0199 6.65997L32.1199 74.22L39.4599 75.94C42.9799 72.5 47.9799 71.08 52.8599 72.24C57.7399 73.4 61.5799 76.9 63.1999 81.54Z",
  fill: "url(#paint1_linear_20693_22895)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.3449 64.0761C61.833 61.9911 63.9189 60.6966 66.0039 61.1847L66.3776 61.2722C66.5037 61.3018 66.627 61.3371 66.7471 61.378C66.8729 61.3947 66.999 61.4177 67.1251 61.4472L67.8726 61.6222C67.9987 61.6518 68.122 61.6871 68.2421 61.728C68.3679 61.7447 68.494 61.7677 68.6201 61.7972L69.3676 61.9722C69.4937 62.0018 69.617 62.0371 69.7371 62.078C69.8629 62.0947 69.989 62.1177 70.1151 62.1472L70.8626 62.3222C70.9887 62.3518 71.112 62.3871 71.2321 62.428C71.3579 62.4447 71.484 62.4677 71.6101 62.4972L71.9839 62.5847C74.0688 63.0729 75.3633 65.1588 74.8752 67.2437C74.3871 69.3287 72.3012 70.6232 70.2162 70.1351L69.8425 70.0476C69.7164 70.018 69.5931 69.9827 69.473 69.9418C69.3472 69.9251 69.2211 69.9021 69.095 69.8726L68.3475 69.6976C68.2214 69.668 68.0981 69.6327 67.978 69.5918C67.8522 69.5751 67.7261 69.5521 67.6 69.5226L66.8525 69.3476C66.7264 69.318 66.6031 69.2827 66.483 69.2418C66.3572 69.2251 66.2311 69.2021 66.105 69.1726L65.3575 68.9976C65.2314 68.968 65.1081 68.9327 64.988 68.8918C64.8622 68.8751 64.7361 68.8521 64.61 68.8226L64.2362 68.7351C62.1513 68.2469 60.8568 66.161 61.3449 64.0761Z",
  fill: "url(#paint2_linear_20693_22895)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.7476 61.0842C49.2423 59.0007 51.3323 57.7129 53.4157 58.2076L53.7895 58.2963C53.9156 58.3263 54.0388 58.3621 54.1589 58.4034C54.2847 58.4205 54.4109 58.4439 54.537 58.4738L55.2845 58.6513C55.4106 58.6813 55.5338 58.7171 55.6539 58.7584C55.7797 58.7755 55.9059 58.7989 56.032 58.8288L56.7795 59.0063C56.9056 59.0363 57.0288 59.0721 57.1489 59.1134C57.2747 59.1305 57.4009 59.1539 57.527 59.1838L58.2745 59.3613C58.4006 59.3913 58.5238 59.4271 58.6439 59.4684C58.7697 59.4855 58.8959 59.5089 59.022 59.5388L59.3957 59.6276C61.4792 60.1223 62.767 62.2123 62.2723 64.2957C61.7776 66.3791 59.6876 67.667 57.6042 67.1723L57.2304 67.0835C57.1043 67.0536 56.9811 67.0178 56.861 66.9765C56.7352 66.9594 56.6091 66.936 56.4829 66.906L55.7354 66.7285C55.6093 66.6986 55.4861 66.6628 55.366 66.6215C55.2402 66.6044 55.1141 66.581 54.9879 66.551L54.2404 66.3735C54.1143 66.3436 53.9911 66.3078 53.871 66.2665C53.7452 66.2494 53.6191 66.226 53.4929 66.196L52.7454 66.0185C52.6193 65.9886 52.4961 65.9528 52.376 65.9115C52.2502 65.8944 52.1241 65.871 51.9979 65.841L51.6242 65.7523C49.5408 65.2576 48.2529 63.1676 48.7476 61.0842Z",
  fill: "url(#paint3_linear_20693_22895)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.1447 58.1361C36.6328 56.0512 38.7187 54.7567 40.8037 55.2448L41.1774 55.3323C41.3036 55.3618 41.4268 55.3972 41.5469 55.4381C41.6727 55.4548 41.7988 55.4778 41.9249 55.5073L42.6724 55.6823C42.7986 55.7118 42.9218 55.7472 43.0419 55.7881C43.1677 55.8048 43.2938 55.8278 43.4199 55.8573L44.1674 56.0323C44.2936 56.0618 44.4168 56.0972 44.5369 56.1381C44.6627 56.1548 44.7888 56.1778 44.9149 56.2073L45.6624 56.3823C45.7886 56.4118 45.9118 56.4472 46.0319 56.4881C46.1577 56.5048 46.2838 56.5278 46.4099 56.5573L46.7837 56.6448C48.8686 57.1329 50.1631 59.2188 49.675 61.3038C49.1869 63.3887 47.101 64.6832 45.016 64.1951L44.6423 64.1076C44.5162 64.0781 44.3929 64.0427 44.2728 64.0019C44.147 63.9852 44.0209 63.9622 43.8948 63.9326L43.1473 63.7576C43.0212 63.7281 42.8979 63.6927 42.7778 63.6519C42.652 63.6352 42.5259 63.6122 42.3998 63.5826L41.6523 63.4076C41.5262 63.3781 41.4029 63.3427 41.2828 63.3019C41.157 63.2852 41.0309 63.2622 40.9048 63.2326L40.1573 63.0576C40.0312 63.0281 39.9079 62.9927 39.7878 62.9519C39.662 62.9352 39.5359 62.9122 39.4098 62.8826L39.036 62.7951C36.9511 62.307 35.6566 60.2211 36.1447 58.1361Z",
  fill: "url(#paint4_linear_20693_22895)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_20693_22895",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 36,
  y: 7,
  width: 12,
  height: 27
}, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5 33.8999L42.9 7.09985L47.1 10.0999L41.7 33.2999L36.5 33.8999Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_20693_22895)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.8 17.6199C43.74 17.4999 43.62 17.4399 43.5 17.4599C43.42 17.4999 43.36 17.5599 43.32 17.6199L42.46 18.9399C42.3 17.2199 43.34 15.8599 43.38 14.1799C43.4 13.9999 43.32 13.8199 43.16 13.7599C42.98 13.6999 42.8 13.8399 42.66 13.9799L41.06 15.5599C40.72 15.8799 40.44 16.2599 40.2 16.6599C39.42 17.9399 38.84 19.4399 38.96 20.9199L34.62 27.9399C34.5 28.1999 34.2 28.2999 33.94 28.1799L24.54 24.3999L24.92 31.1399L34.16 32.8599C36.14 33.3999 37.58 32.0799 38.42 30.2199L42.46 22.4399L42.48 22.5199C43.26 21.1199 43.72 19.5599 43.84 17.9599C43.86 17.8599 43.84 17.7399 43.8 17.6199Z",
  fill: "url(#paint5_linear_20693_22895)"
}))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M13.92 83.3201L13.26 90.6801L23.54 94.2601C25.46 94.9401 26.9 92.4201 25.32 91.1201L25.26 91.0601C22.98 89.2601 19.54 84.7001 19.54 84.7001",
  fill: "#727D79"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6799 82.4399L23.9399 89.3999L33.9999 91.5199C35.8799 91.9199 36.9199 89.3799 35.2799 88.3599L35.1999 88.3199C32.8599 86.8999 28.0599 83.0199 28.0599 83.0199",
  fill: "#727D79"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M0.979959 44.82C0.979959 44.82 0.619959 54.34 7.05996 57.8C13.5 61.28 13.2 85.56 13.2 85.56H20.6V65.44C20.6 63.66 20.18 61.9 19.38 60.32L14.64 50.98L21.9 62.02L23.28 84.9L29.88 84.1V62.58C29.88 58.7 28.52 54.96 26.04 51.98L17.5 41.74L0.979959 44.82Z",
  fill: "#D7D8D6"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1 33.9L27.9 26.42L18.44 22.94C16.04 22.36 13.64 23.82 13.06 26.22C12.92 26.8 12.9 27.4 13 27.98C13.3 29.8 15.6 31.46 17.4 31.84L26.1 33.9Z",
  fill: "#AC41D8"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.38 22.8201H17.22V22.8401C20 24.0001 21.6 26.9201 21.06 29.8801L20.68 32.6401L26.1 33.9201L27.9 26.4401L18.44 22.9601C18.1 22.8801 17.74 22.8401 17.38 22.8201Z",
  fill: "url(#paint6_linear_20693_22895)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M9.13989 22.4599L15.8199 25.2999L18.6199 20.2799L20.3599 20.2399C21.7399 20.0999 21.5399 18.5599 21.4799 17.5799C21.4399 16.8199 21.3999 16.0599 21.3399 15.2999C21.6199 15.3399 21.9799 15.3399 22.1199 15.0999C22.1799 14.9199 22.1799 14.7399 22.0999 14.5799C21.7599 13.3599 21.3199 12.1599 20.8199 11.0199C20.2599 9.79991 19.4999 8.05991 17.9999 7.99991C16.2599 7.93991 14.6199 8.69991 13.0599 9.49991C11.5999 10.2399 10.9399 11.6599 10.8399 13.2599C10.7999 14.0199 10.8999 14.7799 11.1399 15.4999C11.4799 16.1599 11.8599 16.7799 12.2799 17.3999L9.13989 22.4599Z",
  fill: "#8D5524"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3798 13.62C19.5455 13.62 19.6798 13.4857 19.6798 13.32C19.6798 13.1543 19.5455 13.02 19.3798 13.02C19.2141 13.02 19.0798 13.1543 19.0798 13.32C19.0798 13.4857 19.2141 13.62 19.3798 13.62Z",
  fill: "#0E1010"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M16.04 13.0599C16.12 12.3399 16.64 11.7599 17.34 11.6199C18.04 11.4199 18.76 11.4199 19.46 11.2599C19.94 11.1399 20.4 10.9399 20.82 10.6599C21.16 10.4399 21.46 10.1599 21.7 9.81992C22.34 8.85992 22.32 7.57992 21.64 6.63992C20.98 5.71992 19.96 5.25992 18.88 5.59992C17.74 5.93992 16.9 6.87992 15.92 7.55992C15.1 8.13992 14.16 8.53992 13.16 8.73992C12.22 8.93992 11.22 8.95992 10.42 9.47992C10 9.75992 9.64004 10.1399 9.40004 10.5999C8.60004 11.9199 8.46004 13.5999 8.80004 15.1199C9.14004 16.6399 10.04 18.7799 11.94 18.7599C12.78 18.7399 13.54 18.2799 13.96 17.5399C13.44 17.2799 12.9 17.0199 12.6 16.5399C12.34 16.1199 12.24 15.6199 12.32 15.1399C12.36 14.7799 12.5 14.4399 12.72 14.1799C13.26 13.5399 14.2 13.4599 14.84 13.9999C14.98 14.1199 15.08 14.2399 15.18 14.3999C15.24 14.5199 15.32 14.6399 15.44 14.7199C15.6 14.7799 15.8 14.6999 15.88 14.5399C15.96 14.3799 16 14.2199 16 14.0399C15.96 13.6999 15.98 13.3799 16.04 13.0599Z",
  fill: "#000704"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M7.13996 21.52L16 22.46C19.42 23.14 21.66 26.4399 21.04 29.8799L19.16 43.7799L0.959961 44.82L4.33996 23.58C4.59996 22.28 5.81996 21.38 7.13996 21.52Z",
  fill: "#AC41D8"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M1.05998 44.36L0.97998 44.82L1.23998 44.8C1.17998 44.66 1.11998 44.5 1.05998 44.36ZM17.76 33.16C17.68 33.16 17.58 33.16 17.5 33.14L17.12 33.1C15.82 32.96 14.9 31.8 15.04 30.5L15.38 27.44C15.4 27.18 15.62 26.98 15.88 26.98H15.92L19.98 27.44C20.26 27.48 20.46 27.72 20.44 28L20.1 31.04C19.96 32.24 18.94 33.14 17.76 33.16ZM6.85998 21.5C6.69998 21.5 6.53998 21.52 6.37998 21.54C8.55998 21.86 10.18 23.74 10.18 25.94C10.18 26.1 10.18 26.26 10.16 26.42L9.25998 35.66L7.53998 35.44L6.87998 41.3C6.81998 41.84 7.07998 42.36 7.53998 42.66L10.26 44.3L19.16 43.8L21.04 29.9C21.66 26.46 19.42 23.16 16 22.48L9.55998 21.8L7.13998 21.54C7.05998 21.54 6.95998 21.54 6.87998 21.54",
  fill: "url(#paint7_linear_20693_22895)"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M15.14 52.7399L3.20003 46.9399C1.54003 45.9599 0.620031 44.0999 0.820031 42.1799L2.08003 26.6599L7.16003 27.8199C7.86003 27.9799 8.32003 28.6399 8.24003 29.3399L6.92003 41.2599C6.86003 41.7999 7.12003 42.3199 7.58003 42.6199L17.78 48.8399L15.14 52.7399Z",
  fill: "#8D5524"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M0.439941 34.54L9.27994 35.68L10.1799 26.44C10.3999 24 8.59994 21.82 6.13994 21.62C3.69994 21.4 1.51994 23.2 1.31994 25.66L0.439941 34.54Z",
  fill: "#AC41D8"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75994 21.5C3.41994 21.5 1.47994 23.3 1.29994 25.62L0.439941 34.52L9.27994 35.66L10.1799 26.42C10.1999 26.26 10.1999 26.1 10.1999 25.94C10.1799 23.74 8.55994 21.88 6.39994 21.56C6.17994 21.54 5.95994 21.52 5.75994 21.5Z",
  fill: "url(#paint8_linear_20693_22895)"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8999 46.44C15.4199 46.4 16.9399 46.52 18.4399 46.76C18.7799 46.84 19.1399 46.92 19.4999 46.98C19.6999 47.02 20.1199 46.98 20.2999 47.1C20.9799 47.62 19.6799 47.9 19.3399 48C18.7799 48.16 17.7599 48.42 18.1599 49.18C18.6399 50.06 19.6599 50.26 20.5399 50.5C21.1799 50.66 23.0199 51.1 22.8599 52.06C22.7599 52.64 21.6999 53.16 21.2399 53.42C18.3999 54.98 15.4999 53.28 13.1999 51.58C12.6799 51.2 12.1599 50.86 11.6799 50.44",
  fill: "#8D5524"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6399 20.3H15.9199L17.7199 21.92L18.6399 20.3Z",
  fill: "#6B2B09"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7599 15.9001L19.0999 15.5601C19.0999 15.5601 19.3399 16.5601 19.9799 16.6801C20.5999 16.8201 20.7599 15.9001 20.7599 15.9001Z",
  fill: "white"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M15.8799 26.98C15.6199 26.98 15.4 27.18 15.38 27.44L15.0399 30.5C14.8999 31.8 15.8199 32.96 17.1199 33.1L17.4999 33.14C17.5799 33.16 17.68 33.16 17.76 33.16C18.96 33.16 19.9599 32.26 20.0999 31.06L20.4399 28C20.4799 27.72 20.2799 27.46 19.9999 27.44L15.9399 26.98H15.8799Z",
  fill: "url(#paint9_linear_20693_22895)"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M41.46 18.52C41.4 18.4 41.28 18.34 41.16 18.36C41.08 18.4 41.02 18.46 40.98 18.52L40.12 19.84C39.96 18.12 41 16.76 41.04 15.08C41.06 14.9 40.98 14.72 40.82 14.66C40.64 14.6 40.46 14.74 40.32 14.88L38.72 16.46C38.38 16.78 38.1 17.16 37.86 17.56C37.08 18.84 36.5 20.34 36.62 21.82L32.28 28.84C32.16 29.1 31.86 29.2 31.6 29.08L27.66 27.72L26.26 32.72L31.78 33.8C33.76 34.34 35.2 33.02 36.04 31.16L40.08 23.38L40.1 23.46C40.88 22.06 41.34 20.5 41.46 18.9C41.5 18.76 41.5 18.64 41.46 18.52Z",
  fill: "#8D5524"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20693_22895",
  x1: 16.0164,
  y1: 78.6124,
  x2: 76.3835,
  y2: 18.2453,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E97903"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0739316,
  stopColor: "#EC8709"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2075,
  stopColor: "#EF9910"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3662,
  stopColor: "#F2A616"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5723,
  stopColor: "#F4AE19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4B01A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_20693_22895",
  x1: 50.2134,
  y1: 83.5743,
  x2: 68.3754,
  y2: 6.37365,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0902665,
  stopColor: "#A141CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2682,
  stopColor: "#8F40B4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4632,
  stopColor: "#833FA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6863,
  stopColor: "#7B3F9B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_20693_22895",
  x1: 67.5127,
  y1: 68.2267,
  x2: 68.7261,
  y2: 63.0687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_20693_22895",
  x1: 54.912,
  y1: 65.2623,
  x2: 56.1255,
  y2: 60.1044,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_20693_22895",
  x1: 42.3113,
  y1: 62.298,
  x2: 43.5248,
  y2: 57.14,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0770749,
  stopColor: "#A641D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4555,
  stopColor: "#8E40B2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7765,
  stopColor: "#7E3F9F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_20693_22895",
  x1: 24.5408,
  y1: 23.3828,
  x2: 43.8444,
  y2: 23.3797,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0016121
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1444,
  stopColor: "#040205"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3094,
  stopColor: "#0F0813"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4855,
  stopColor: "#21112A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6692,
  stopColor: "#3B1F4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8569,
  stopColor: "#5C3074"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9992,
  stopColor: "#793F98"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_20693_22895",
  x1: 12.1476,
  y1: 29.7577,
  x2: 26.9699,
  y2: 27.5742,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7411B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AC41D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_20693_22895",
  x1: 1.02461,
  y1: 33.1576,
  x2: 21.1936,
  y2: 33.1576,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7411B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AC41D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_20693_22895",
  x1: -0.718874,
  y1: 30.8654,
  x2: 10.7318,
  y2: 27.5689,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7411B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AC41D8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_20693_22895",
  x1: 1.02458,
  y1: 30.0735,
  x2: 21.1936,
  y2: 30.0735,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E049B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7411B7"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndicacaoP2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indicacao_p2.934ceea457054b753ff96afd7d625ddd.svg";